/**
 * @constant {string} REACT_DOM_ID - The ID of the React DOM element.
 */
const REACT_DOM_ID = 'fe';
/**
 * @constant {string} SURE_HITS_ID - The ID of the Sure hits DOM element.
 */
const SURE_HITS_ID = 'qsWidgetContainer';

/**
 * @constant {Object} SRC_IDS - An object containing source IDs for different insurance types.
 * @property {number} auto - Source ID for auto insurance.
 * @property {number} health - Source ID for health insurance.
 * @property {number} life - Source ID for life insurance.
 * @property {number} home - Source ID for home insurance.
 */
export const SRC_IDS = {
    auto: 693946,
    health: 694022,
    life: 694021,
    home: 693993,
};

/**
 * @constant {Object} QUOTE_TYPES - An object containing quote types.
 * @property {string} COMMERCIAL - Quote type for commercial insurance.
 * @property {string} PERSONAL - Quote type for personal insurance.
 */
export const QUOTE_TYPES = {
    COMMERCIAL: 'commercial',
    PERSONAL: 'personal',
};

/**
 * Creates a new surehits div element with the ID 'qsWidgetContainer' and inserts it after the React DOM element.
 *
 * @function addSureHitsContainerAfterReactDOM
 * @returns {HTMLElement} The newly created surehits div element with the ID 'qsWidgetContainer'.
 */
export const addSureHitsContainerAfterReactDOM = () => {
    // get the Div that react is rendering to
    const reactElm = document.getElementById(REACT_DOM_ID);
    if (!reactElm || !(reactElm instanceof HTMLElement)) {
        return null;
    }

    // Create a new div element with the ID 'qsWidgetContainer' for surehits to render to
    // <div id="qsWidgetContainer" class="surehits-custom" data-testid="surehits-container"></div>
    const sureHitsElm = document.createElement('div');
    sureHitsElm.id = SURE_HITS_ID;
    sureHitsElm.className = 'surehits-custom';
    sureHitsElm.setAttribute('data-testid', 'surehits-container');
    sureHitsElm.setAttribute('data-quote-type', QUOTE_TYPES.PERSONAL);

    // add the new sureHits div right after the react div
    reactElm.insertAdjacentElement('afterend', sureHitsElm);

    return sureHitsElm;
};

/**
 * Adds a disclosure container after the surehits element.
 *
 * @function addDisclosureContainerAfterSureHits
 * @param {HTMLElement} sureHitsElm - The surehits element.
 * @returns {HTMLElement} The disclosure container element.
 */

export const addDisclosureContainerAfterSureHits = sureHitsElm => {
    if (!sureHitsElm || !(sureHitsElm instanceof HTMLElement)) {
        return null;
    }

    let disclosureElm = document.getElementById('sure-hits-disclosure-container');

    if (!disclosureElm || !(disclosureElm instanceof HTMLElement)) {
        disclosureElm = document.createElement('div');
        disclosureElm.id = 'sure-hits-disclosure-container';
    }

    sureHitsElm.insertAdjacentElement('afterend', disclosureElm);

    return disclosureElm;
};
